export default async function asyncForEach(array: any[], callback: (value: any, index: number, array?: any[]) => any){
    for (let index = 0; index < array.length; index++) {
        await callback(array[index], index, array);
    }
}